import { ViewModel,View, ViewModelMessage } from "binder"
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
import  { ColumnsEditorViewModelView } from "./columnsEditorViewModel-view"
import { PopupColumnsEditorViewModel } from "./popupColumnsEditor/popupColumnsEditor-viewModel";

export class ColumnsEditorViewModelViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ColumnsEditorViewModelView();
    }
    public getTypeId(): string {
        return "VM-990548A5-4237-41CC-B44E-73C10A87576B"
    }

    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;

    async edit(){
        let editor = new PopupColumnsEditorViewModel(this);
        await editor.loadData();
        editor.loadColumns(this.value);
        let result =await this.requestShowingPopup(editor);
        if(result!=null){
            this.value = result;
            this.requestConfirm();
        }
    }

    setValue(v: string) {
        this.value = v;
    }
    getValue(): string {
        return this.value;
    }
    requestConfirm() {
    }
}
